module.exports = __webpack_public_path__ + "media/images/backgrounds/credit-card-world-map-background-53873528c2588b76fe67de39658b24d9.png";